module.exports = __webpack_public_path__ + "static/img/btn.2945b35.f1be911.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/live/btn.2945b35.png
// module id = /hTi
// module chunks = 56